import CourseForm from '@/views/App/Course/PrivateCoaching/Form.vue';
import BBQCourseForm from '@/views/App/Course/PrivateCoaching/BBQForm.vue';
import CoursePrivateCoachingList from '@/views/App/Course/PrivateCoaching/List.vue';

const routesCoursePrivateCoaching = [
    {
        path: 'list',
        name: 'coursePrivateCoachingList',
        component: CoursePrivateCoachingList
    },
    {
        path: 'form/:id?',
        name: 'coursePrivateCoachingForm',
        component: CourseForm
    },
    {
        path: 'bbq/form/:id?',
        name: 'bbqCoursePrivateCoachingForm',
        component: BBQCourseForm
    },
  ];

export default routesCoursePrivateCoaching;